import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-change",
  "use": "icon-change-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-change\"><path d=\"M285.376 320.64H843.84a48 48 0 1 1 0 96H184.32a54.4 54.4 0 0 1-38.336-93.056l174.976-173.44a48 48 0 1 1 67.584 68.224L285.44 320.64z m452.096 381.888H178.944a48 48 0 0 1 0-96h659.584a54.4 54.4 0 0 1 38.272 93.056L701.824 872.96a48 48 0 1 1-67.52-68.224l103.168-102.208z\" fill=\"#666666\" p-id=\"2700\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol